$(function() {
    var url = window.location.host;
    var ts = new Date().valueOf();

    function initPaging() {

        $('.element0').click(function () {
            var str = $(this).attr('id');

            $('.element' + str).load('http://' + url + '/pokaz_prod.php?a=1&id=' + str, null);
            $('.element' + str).toggle();

        });

    }
    initPaging();

    /*
     * Sidebar (brandList)
     */

    /* Pozwól na klikanie pozycji rozwijanych kategorii */
    $('#brandList .main ul').on('click', 'a', function (e) {
         e.stopPropagation();
    });

    /* Pozwól na klikanie w główne kategorie, gdy są rozwinięte */
    $('#brandList').on('click', 'a.first', function (e) {
        if (!$(this).parent().hasClass('collapsed')) {
            e.stopPropagation();
        }
    });

    /* Rozwijanie aktywnej kategorii */
    if ($('#brandList .active').length) {
        var active = $('#brandList .active');
        var parent = active.parent();
        var child = parent.find('.collapse');
        
        while (child.length) {
            // child.removeClass('collapse');
            child.collapse('show');

            child = child.find('collapse');
        }

        while (parent.is(':not(#brandList)')) {
            if (parent.hasClass('collapse')) {
                parent.collapse('show');
            }

            parent = parent.parent();
        }
    }

    $('#priceRange').on('click change', 'input', function (e) {
        $('form#priceRange').find('input:checked').prop('checked', false);
        $(this).prop('checked', true);
        $('form#priceRange').submit();
    }); 


    // slider produktów na urządzeniach mobilnych
    if($(window).width() < 768){

        $('.product-single').detach().appendTo('#mobile-slider');

        $('#mobile-slider').slick({
            dots: true,
            autoplay: true,
            arrows: false,
            swipe: true,
            swipeToSlide: true,
            touchMove: true
        });
    }

});